import * as React from 'react';
import { CaretDown } from '@phosphor-icons/react';
import * as SelectPrimitive from '@radix-ui/react-select';

import { cn } from '@/lib/utils';

const SelectTrigger = React.forwardRef<
    React.ElementRef<typeof SelectPrimitive.Trigger>,
    React.ComponentPropsWithoutRef<typeof SelectPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
    <SelectPrimitive.Trigger
        ref={ref}
        className={cn(
            'flex w-full items-center justify-between rounded-md border border-input bg-background px-3 py-[13px] text-2xs ring-offset-background focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 data-[placeholder]:text-grey-600 [&>span]:line-clamp-1',
            className,
        )}
        {...props}
    >
        {children}

        <SelectPrimitive.Icon asChild>
            <CaretDown
                className="text-grey-900"
                size={20}
            />
        </SelectPrimitive.Icon>
    </SelectPrimitive.Trigger>
));
SelectTrigger.displayName = SelectPrimitive.Trigger.displayName;

export { SelectTrigger };
